import { Banner } from '@components';
import type { FC } from 'react';

type Props = {
  entityName: string;
};

export const ArchivedPlantWarning: FC<Props> = ({ entityName }) => (
  <Banner severity='warning' title={`This ${entityName} is associated with an archived location`}>
    Changes will be saved but this location is no longer active.
  </Banner>
);
